/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BookNotepadIcon16Light } from './BookNotepadIcon16Light';
import { BookNotepadIcon16Regular } from './BookNotepadIcon16Regular';
import { BookNotepadIcon16Solid } from './BookNotepadIcon16Solid';
import { BookNotepadIcon20Light } from './BookNotepadIcon20Light';
import { BookNotepadIcon20Regular } from './BookNotepadIcon20Regular';
import { BookNotepadIcon20Solid } from './BookNotepadIcon20Solid';
import { BookNotepadIcon24Regular } from './BookNotepadIcon24Regular';
import { BookNotepadIcon24Solid } from './BookNotepadIcon24Solid';
import { BookNotepadIcon32Regular } from './BookNotepadIcon32Regular';
import { BookNotepadIcon64Regular } from './BookNotepadIcon64Regular';
var sizes = {
    16: {
        light: BookNotepadIcon16Light,
        regular: BookNotepadIcon16Regular,
        solid: BookNotepadIcon16Solid,
    },
    20: {
        light: BookNotepadIcon20Light,
        regular: BookNotepadIcon20Regular,
        solid: BookNotepadIcon20Solid,
    },
    24: {
        regular: BookNotepadIcon24Regular,
        solid: BookNotepadIcon24Solid,
    },
    32: {
        regular: BookNotepadIcon32Regular,
    },
    64: {
        regular: BookNotepadIcon64Regular,
    },
};
export var BookNotepadIcon = forwardRef('BookNotepadIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
